import alt from '../alt'
import BookingActions from '../actions/BookingActions'

class BookingStore {
  constructor () {
    this.bindActions(BookingActions)

    this.bookings = []
  }

  onFetchedBookings (bookings) {
    this.bookings = bookings
  }
}

export default alt.createStore(BookingStore, 'BookingStore')
